import { Link, LinkButton, Region, Stack } from '@strongdm/design-system'
import clsx from 'clsx'
import { FC, PropsWithChildren, useState } from 'react'

import sdmTextLogo from './images/sdmTextLogo.svg'
import styles from './LandingLayout.module.css'

export const LandingLayout: FC<PropsWithChildren> = ({ children }) => {
  const [year] = useState(() => new Date().getFullYear())

  return (
    <Stack
      spacing="s5"
      type="column"
      className={clsx(styles.background)}
      hAlign="center"
      vAlign="flex-start"
    >
      <Stack vAlign="center" hAlign="center" className="sdm--padding-top--s7">
        <Link href="/">
          <img
            src={sdmTextLogo}
            height={68}
            alt="No resources matched your search."
          />
        </Link>
      </Stack>
      <Stack type="column" spacing="s4">
        <Region className={clsx(styles.contentCard)}>{children}</Region>
        <Stack
          className={clsx(styles.legal)}
          spacing="s4"
          grow
          hAlign="space-between"
        >
          <Region grow>&copy; {year} StrongDM</Region>
          <Region>
            <LinkButton
              volume="whisper"
              context="neutral"
              size="inline"
              inverted
              target="_blank"
              href="https://www.strongdm.com/privacy"
            >
              Privacy Policy
            </LinkButton>
          </Region>
          <Region>
            <LinkButton
              volume="whisper"
              context="neutral"
              size="inline"
              inverted
              target="_blank"
              href="https://www.strongdm.com/terms-of-use"
            >
              Terms of Use
            </LinkButton>
          </Region>
        </Stack>
      </Stack>
    </Stack>
  )
}
